import { withAnalyticsHandler } from 'hoc/with-analytics-handler'

export const TrackedA = withAnalyticsHandler('a', ['Click'])
